import type { FC } from 'react'

import { Select } from '@skytech/ui'

import { useTranslation } from '@/components/i18n/hooks'
import { Translation } from '@/components/i18n/Translation'
import { useSearchParamsByKey } from '@/hooks/searchParams'

import type { TradeInOrderCounter } from '../resources'

export const StatusSelect: FC<{ orderCounter: TradeInOrderCounter }> = ({ orderCounter }) => {
  const translate = useTranslation()
  const [queryStatus, setQueryStatus] = useSearchParamsByKey('status')

  const statusOptions = Object.keys(orderCounter).map(orderStatus => ({
    value: orderStatus,
    label: translate(`trade_in_order_status/${orderStatus}`),
  }))

  return (
    <Select
      id="status-dropdown"
      className="flex md:hidden"
      marginBottom={18}
      value={queryStatus || ''}
      label={<Translation id="Select status" />}
      options={statusOptions}
      onChange={status => {
        if (!status) return
        if (typeof status.value !== 'string') throw Error('Incorrect status!')
        setQueryStatus(status.value)
      }}
    />
  )
}
